import { render, staticRenderFns } from "./CreateLabelModal.vue?vue&type=template&id=3d8cb082"
import script from "./CreateLabelModal.vue?vue&type=script&lang=js"
export * from "./CreateLabelModal.vue?vue&type=script&lang=js"
import style0 from "./CreateLabelModal.vue?vue&type=style&index=0&id=3d8cb082&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports